import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';
import * as M from "materialize-css/dist/js/materialize";
import * as moment from 'moment';

@Component({
	selector: 'unos-izmjena-vozilo',
	templateUrl: './unos-izmjena-vozilo.component.html',
	styleUrls: ['./unos-izmjena-vozilo.component.css']
})
export class UnosIzmjenaVoziloComponent implements OnInit {
	@Input() id;
	@Input() vlasnikId;
	@Input() nazivPLice;

	@Output() onInsertVozilo = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();

	constructor(private http: HttpClient, public globalSrvc: GlobalService) { }
	loading = false;
	msg : any;
	daneStavke : any = [{ 'id': '0', 'naziv': 'Ne', jeOdabran: false }, { 'id': '1', 'naziv': 'Da', jeOdabran: false }];
	vozilo : any = {id : null, registracija : null, vin : null, komOznaka : null, idMarka : null, idModel : '',  prvo_pustanje : null, vrsta_vozila_id : null};
	marke : any = [];	
	modeli : any = [];
	vrsteVozila : any = [];

	err_registracija = false;
	err_registracija_poruka = '';
	err_vin = false;
	err_vin_poruka = '';
	err_komOznaka = false;
	err_komOznaka_poruka = '';
	err_idMarka = false;
	err_idMarka_poruka = '';
	err_idModel = false;
	err_idModel_poruka = '';
	err_datum = false;
	err_datum_poruka = '';

	modalInstance : any = null;
	nazivSifrarnika : any = null;

	ngOnInit() {
		this.ucitaj();
	}

	server_data : any = null;

	ucitaj() {
		this.loading = true;
		this.http.get('vlasnici/vozilo/detaljno', { params: { id: this.id?this.id:"" } })
			.subscribe(data => {
				this.loading = false;
				this.vozilo = data;
				this.marke = this.vozilo.marke; 
				this.modeli = this.vozilo.modeli;
				this.vrsteVozila = this.vozilo.vrsteVozila;

				this.vozilo.marke = [];
				this.vozilo.tahmakers = [];
				this.vozilo.modeli = [];
				this.vozilo.vrsteVozila = [];

				setTimeout(() => {
					M.updateTextFields();
				}, 300);
				
				//this.ucitajSkole();
			}
			, error => {
				this.loading = false;
			});
	}

	markaSelected(event){
		this.loading = true;
		this.http.get('modeli', { params: { idMarka: this.vozilo.idMarka?this.vozilo.idMarka:"" } })
		.subscribe(data => {
			this.loading = false;
			this.modeli = data;
		}
		, error => {
			this.loading = false;
		});
	}

	toastTimeout = 5000;

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	savedata(){
		if (!this.vozilo.registracija) {
			this.err_registracija = true;
			this.err_registracija_poruka = 'Morate definisati polje Reg. broj.';
			M.toast({html: this.err_registracija_poruka, displayLength : this.toastTimeout});
			return;
		}
		this.err_registracija = false;
		this.err_registracija_poruka = '';

		if (!this.vozilo.vin) {
			this.err_vin = true;
			this.err_vin_poruka = 'Morate definisati polje Broj šasije.';
			M.toast({html: this.err_vin_poruka, displayLength : this.toastTimeout});
			return;
		}
		this.err_vin = false;
		this.err_vin_poruka = '';

		/*if (!this.vozilo.komOznaka) {
			this.err_komOznaka = true;
			this.err_komOznaka_poruka = 'Morate definisati polje Komercijalna oznaka.';
			M.toast({html: this.err_komOznaka_poruka, displayLength : this.toastTimeout});
			return;
		}
		this.err_komOznaka = false;
		this.err_komOznaka_poruka = '';*/

		if (!this.vozilo.idMarka) {
			this.err_idMarka = true;
			this.err_idMarka_poruka = 'Morate definisati polje Proizvođač.';
			M.toast({html: this.err_idMarka_poruka, displayLength : this.toastTimeout});
			return;
		}
		this.err_idMarka = false;
		this.err_idMarka_poruka = '';

		if (!this.vozilo.idModel) {
			this.err_idModel = true;
			this.err_idModel_poruka = 'Morate definisati polje Tip vozila.';
			M.toast({html: this.err_idModel_poruka, displayLength : this.toastTimeout});
			return;
		}
		this.err_idModel = false;
		this.err_idModel_poruka = '';

		if (this.vozilo.prvo_pustanje) {
			var date = moment(this.vozilo.prvo_pustanje, 'DD.MM.YYYY', true);

			if (!date || !date.isValid()){
				this.err_datum = true;
				this.err_datum_poruka = 'Polje "Datum prvog puštanja" nije valjano formatirano. Unesite datum u formatu dd.mm.gggg. Npr. 31.12.2022';
				M.toast({html: this.err_datum_poruka, displayLength : this.toastTimeout});
				return;
			}
		}

		let url = 'vlasnici/vozilo/dodaj';
		if (this.id){
			url = 'vlasnici/vozilo/izmijeni';
		}

		this.loading = true;
		this.vozilo.idVlasnika = this.vlasnikId;
		
		setTimeout(() => {				
		
			this.http.post(url, this.vozilo)
				.subscribe(data => {
					this.msg = data;
					//console.log(data);
					this.loading = false;

					if (this.msg.id == 1) {
						if (!this.id) this.vozilo.id = this.msg.newId;
						
						let markaObj = this.marke.find((item) => item.id == this.vozilo.idMarka);
						if (markaObj) this.vozilo.nazivMarka = markaObj.naziv; 

						if (this.onInsertVozilo)
							this.onInsertVozilo.emit(this.vozilo);
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : this.toastTimeout});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 1000);
	}

	dodajProizvodjaca(){
		this.nazivSifrarnika = "marka";
		this.openSifrarnikModal();	
	}
	
	dodajProizvodjacaTaho(){
		this.nazivSifrarnika = "tah_maker";
		this.openSifrarnikModal();	
	}

	dodajTipVozila(){
		this.nazivSifrarnika = "model";
		this.openSifrarnikModal();	
	}

	dodajVrstuVozila(){
		this.nazivSifrarnika = "vrsta_vozila";
		this.openSifrarnikModal();	
	}

	openSifrarnikModal(){
		var elem = document.getElementById('modalsifrarnik');					
		this.modalInstance = M.Modal.init(elem, {onCloseEnd : () => {}});
		this.modalInstance.open();
	}

	onInsertSifrarnik(obj){
		if (this.modalInstance) this.modalInstance.close();
		if (!obj || !obj.id) return;
		
		let arr = null;
		if (this.nazivSifrarnika == "marka") arr = this.marke;		
		if (this.nazivSifrarnika == "model") arr = this.modeli;
		if (this.nazivSifrarnika == "vrsta_vozila") arr = this.vrsteVozila;
		if (!arr) return;

		arr.push(obj);
		arr.sort((a,b) => (a.naziv < b.naziv)?-1:1);
		
		if (this.nazivSifrarnika == "marka") this.vozilo.idMarka = obj.id;				
		if (this.nazivSifrarnika == "model") this.vozilo.idModel = obj.id;	
		if (this.nazivSifrarnika == "vrsta_vozila") this.vozilo.vrsta_vozila_id = obj.id;	
	}

	onCancelSifrarnik(){		
		if (this.modalInstance) this.modalInstance.close();
	}
}
